<template>
  <div id="loader-component" class="loader-component w-100">
    <div id="loading-bg">
      <div class="loader" />
      <div style="margin-top: 4px">
        <h4>{{ loadingText }}</h4>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted } from 'vue'
import { useRootStore } from '@/stores/root'

const rootStore = useRootStore()

const loadingText = computed(
  () => rootStore.fullScreenLoadingText || 'Loading...',
)
onMounted(() => {
  const loaderColor =
    localStorage.getItem('Materio-initial-loader-bg') || '#FFFFFF'
  const primaryColor =
    localStorage.getItem('Materio-initial-loader-color') || '#7367F0'

  if (loaderColor)
    document.documentElement.style.setProperty(
      '--initial-loader-bg',
      loaderColor,
    )
  if (primaryColor)
    document.documentElement.style.setProperty(
      '--initial-loader-color',
      primaryColor,
    )
})
</script>
<style scoped>
.loader-component {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vh;
  height: 100vh;
  z-index: 99999999;
}

#loading-bg {
  position: fixed;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, 0.2);
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);
  backdrop-filter: blur(1px);
  -webkit-backdrop-filter: blur(1px);
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.4);
  block-size: 100%;
  inline-size: 100%;
}

.loader {
  width: 50px;
  padding: 8px;
  aspect-ratio: 1;
  border-radius: 50%;
  background: #002544;
  --_m: conic-gradient(#0000 10%, #000), linear-gradient(#000 0 0) content-box;
  -webkit-mask: var(--_m);
  mask: var(--_m);
  -webkit-mask-composite: source-out;
  mask-composite: subtract;
  animation: l3 1s infinite linear;
}

@keyframes l3 {
  to {
    transform: rotate(1turn);
  }
}
</style>
